module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portlet light inbox-body"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-bubble font-hide hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-hide bold uppercase"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.messageGroup.subject) + "\n\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.messageGroup.student) ? _c('span', {
    staticClass: "caption-helper"
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno:")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.messageGroup.student.name) + "\n\t\t\t\t\t"), (_vm.messageGroup.student.schoolClass) ? _c('span', [_vm._v("\n\t\t\t\t\t\t(" + _vm._s(_vm.messageGroup.student.schoolClass.description) + ")\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ol', {
    staticClass: "chats"
  }, _vm._l((_vm.messages), function(msg) {
    return _c('li', {
      class: {
        'out': _vm.loggedUserId === msg.from.userId, 'in': _vm.loggedUserId !== msg.from.userId
      }
    }, [_c('img', {
      staticClass: "avatar img-thumbnail",
      attrs: {
        "src": msg.from.photoURL
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(msg.from.name))]), _vm._v(" "), _c('span', {
      staticClass: "datetime"
    }, [_vm._v("às " + _vm._s(_vm._f("date")(msg.sentDateTime, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('strong', {
      staticClass: "body"
    }, [_vm._v(_vm._s(msg.message))]), _vm._v(" "), _c('br'), _vm._v(" "), (msg.usersRead) ? _c('popover', {
      attrs: {
        "placement": "right",
        "title": "Mensagem lida por",
        "width": "350",
        "trigger": "hover"
      }
    }, [_c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "slot": "reference",
        "type": "button"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(msg.status, 'MessageStatusType')) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
      staticClass: "list-group"
    }, _vm._l((msg.usersRead), function(user, index) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(user.userName) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("em " + _vm._s(_vm._f("date")(user.readDateTime, "DD/MM/YYYY hh:MM:ss")) + ")")])])
    }))]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('form', {
    staticClass: "chat-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-cont emoji-text relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "readMessageContent",
      "placeholder": "Escreva sua mensagem aqui...",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emojiPickerVisible),
      expression: "emojiPickerVisible"
    }],
    staticClass: "absolute",
    attrs: {
      "exclude": ['flags', 'symbols'],
      "i18n": _vm.i18n,
      "title": "Emoji",
      "set": "apple"
    },
    on: {
      "click": _vm.addEmoji
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-cont"
  }, [_c('button', {
    staticClass: "btn green-jungle icn-only",
    attrs: {
      "type": "submit",
      "id": "readMessageSend"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviar")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn green m-t-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emojiPickerVisible = !_vm.emojiPickerVisible
      }
    }
  }, [_c('emoji', {
    attrs: {
      "emoji": "grinning",
      "size": 15
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEmojis\n\t\t\t\t\t\t")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para usar "), _c('em', [_vm._v("emojis")]), _vm._v(" clique no botão acima.")]), _c('br'), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_c('strong', [_vm._v("Observação:")]), _vm._v(" no navegador os "), _c('em', [_vm._v("emojis")]), _vm._v(" podem aparecer em forma de [], mas ao enviar aparecerá o "), _c('em', [_vm._v("emoji")]), _vm._v(" selecionado.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.messageGroupUsers) ? _c('message-users', {
    attrs: {
      "users": _vm.messageGroupUsers
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-468dfdf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-reply/message-reply.vue
// module id = 1063
// module chunks = 1